import React from "react";

export default function SourceModeTabs({ mode, setMode }) {
  const modes = ["manual", "import", "api"];

  return (
    <div
      style={{
        display: "flex",
        borderBottom: "1px solid #ddd",
        marginBottom: 16,
      }}
    >
      {modes.map((m) => {
        const active = mode === m;

        return (
          <button
            key={m}
            onClick={() => setMode(m)}
            style={{
              padding: "10px 18px",
              cursor: "pointer",
              border: "none",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              background: active ? "#2563eb" : "#f3f4f6",
              color: active ? "#fff" : "#374151",
              fontWeight: active ? 600 : 500,
              borderBottom: active
                ? "2px solid #2563eb"
                : "2px solid transparent",
            }}
          >
            {m === "manual" && "Manual"}
            {m === "import" && "Import"}
            {m === "api" && "API"}
          </button>
        );
      })}
    </div>
  );
}
